"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _imageLoader = _interopRequireDefault(require("../../../image-loader"));
var _heading = _interopRequireDefault(require("../../../heading"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * A `Slide` can be used within a `SwipeDeck` for a pre-styled slide that contains an image sitting above a header and some body content.
 *
 * Images within the slides are defaulted to a 16:9 aspect-ratio. This is acheived with a width: 16 and a height: 9 within the `imageLoaderProps.wrapInFlex` properties. You can modify this by passing in your own `wrapInFlex` properties.
 */
var Slide = function Slide(_ref) {
  var imageUrl = _ref.imageUrl,
    imageAltText = _ref.imageAltText,
    imageLoaderProps = _ref.imageLoaderProps,
    headingContent = _ref.headingContent,
    _ref$headingTagName = _ref.headingTagName,
    headingTagName = _ref$headingTagName === void 0 ? 'h1' : _ref$headingTagName,
    bodyContent = _ref.bodyContent;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/_react["default"].createElement(_imageLoader["default"], _extends({
    alt: imageAltText,
    src: imageUrl,
    wrapInFlex: {
      enabled: true,
      width: 16,
      height: 9
    }
  }, imageLoaderProps, {
    flexEmbedWrapperClassName: "mb3 overflow-hidden"
  })), /*#__PURE__*/_react["default"].createElement(_heading["default"], {
    className: "mb3 mx3 text-semibold",
    size: "sm",
    tagName: headingTagName
  }, headingContent), /*#__PURE__*/_react["default"].createElement("p", {
    className: "mb3 mx3"
  }, bodyContent));
};
Slide.displayName = 'Slide';
Slide.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `src` of the image.
   */
  imageUrl: _propTypes["default"].string,
  /**
   * `alt` text for the image.
   */
  imageAltText: _propTypes["default"].string,
  /**
   * Props that are passed to the `ImageLoader` component. Refer to the [ImageLoader](/components/images) documentation for more details on these props.
   */
  imageLoaderProps: _propTypes["default"].object,
  /**
   * Content to be rendered for the header.
   */
  headingContent: _propTypes["default"].node,
  /**
   * Use this prop to specify the tagName of the header.
   */
  headingTagName: _propTypes["default"].string,
  /**
   * Content to be rendered for the body, below the header.
   */
  bodyContent: _propTypes["default"].node
} : {};
var _default = exports["default"] = Slide;